export default function PainPoints() {
  const painPoints = [
    {
      title: 'Falta de integração entre canais de marketing',
      icon: 'ri-links-line'
    },
    {
      title: 'Investimentos sem leitura clara de dados',
      icon: 'ri-line-chart-line'
    },
    {
      title: 'Dependência excessiva de tráfego pago',
      icon: 'ri-funds-line'
    },
    {
      title: 'Dificuldade em escalar com segurança',
      icon: 'ri-arrow-up-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Os gargalos mais comuns em empresas em crescimento
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-10 sm:mb-12 md:mb-16">
          {painPoints.map((point, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 sm:p-8 rounded-xl hover:shadow-lg transition-all group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-600 rounded-lg mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${point.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 leading-snug">
                {point.title}
              </h3>
            </div>
          ))}
        </div>

        <p className="text-base sm:text-lg md:text-xl text-center text-gray-700 font-medium max-w-2xl mx-auto px-4">
          Crescer exige clareza, método e tomada de decisão baseada em dados.
        </p>
      </div>
    </section>
  );
}
